import axiosInstance from '../../lib/axios';

export const fetchAudios = async (params = {}) => {
  const response = await axiosInstance.get('/audios/', { params });
  return response.data;
};

export const fetchAudioById = async (id) => {
  const response = await axiosInstance.get(`/audios/${id}/`);
  return response.data;
};

export const createAudio = async (data) => {
  const response = await axiosInstance.post('/audios/', data);
  return response.data;
};

export const updateAudio = async (id, data) => {
  const response = await axiosInstance.put(`/audios/${id}/`, data);
  return response.data;
};

export const deleteAudio = async (id) => {
  const response = await axiosInstance.delete(`/audios/${id}/`);
  return response.data;
};

export const bulkUpdateAudioAttributes = async (audioIds, set, clear) => {
  const response = await axiosInstance.post('/audios/bulk/attributes/', {
    audio_ids: audioIds,
    set,
    clear,
  });
  return response.data;
};

export const bulkDeleteAudios = async (audioIds) => {
  const response = await axiosInstance.post('/audios/bulk/delete/', { audio_ids: audioIds });
  return response.data;
};

export const fetchAudioSessions = async (audioId) => {
  const response = await axiosInstance.get(`/audios/${audioId}/sessions/`);
  return response.data;
};

export const addAudioSession = async (audioId, data) => {
  const response = await axiosInstance.post(`/audios/${audioId}/sessions/`, data);
  return response.data;
};

export const deleteAudioSession = async (audioId, sessionType) => {
  const response = await axiosInstance.delete(`/audios/${audioId}/sessions/${sessionType}/`);
  return response.data;
};

// N sessions in one call. Rows whose assets are not ready, or whose title already
// exists, come back under `skipped` instead of failing the batch.
export const bulkCreateAudios = async ({ items, defaults, publishNow }) => {
  const response = await axiosInstance.post('/audios/bulk/', {
    items,
    defaults,
    publish_now: Boolean(publishNow),
  });
  return response.data;
};

// Which of these titles the catalog already holds, so the grid can warn before
// a byte is uploaded.
export const fetchExistingTitles = async (titles) => {
  const response = await axiosInstance.get('/audios/bulk/titles/', {
    params: { titles: titles.join(',') },
  });
  return response.data.existing || [];
};
